<template>
  <transition-group
    tag="ul"
    :class="[
      'zm-upload-list',
      'zm-upload-list--' + listType,
      { 'is-disabled': disabled }
    ]"
    name="zm-list"
  >
    <li
      v-for="(file, index) in files"
      :class="['zm-upload-list__item', 'is-' + file.status, focusing ? 'focusing' : '']"
      :key="'zm-upload-list-' + index"
      tabindex="0"
      @keydown.delete="!disabled && $emit('remove', file)"
      @focus="focusing = true"
      @blur="focusing = false"
      @click="focusing = false"
    >
      <img
        class="zm-upload-list__item-thumbnail"
        v-if="file.status !== 'uploading' && ['picture-card', 'picture'].indexOf(listType) > -1"
        :src="file.url" alt=""
      >
      <a class="zm-upload-list__item-name" @click="handleClick(file)">
        <i class="zm-icon-document"></i>{{file.name}}
      </a>
      <label class="zm-upload-list__item-status-label">
        <i :class="{
          'zm-icon-upload-success': true,
          'zm-icon-success': listType === 'text',
          'zm-icon-ok': ['picture-card', 'picture'].indexOf(listType) > -1
        }"></i>
      </label>
      <i class="zm-icon-close" v-if="!disabled" @click="$emit('remove', file)"></i>
      <i class="zm-icon-close-tip" v-if="!disabled">{{ t('upload.deleteTip') }}</i>
      <!--因为close按钮只在li:focus的时候 display, li blur后就不存在了，所以键盘导航时永远无法 focus到 close按钮上-->
      <zm-progress
        v-if="file.status === 'uploading'"
        :type="listType === 'picture-card' ? 'circle' : 'line'"
        :stroke-width="listType === 'picture-card' ? 6 : 2"
        :percentage="parsePercentage(file.percentage)">
      </zm-progress>
      <span class="zm-upload-list__item-actions" v-if="listType === 'picture-card'">
        <span
          class="zm-upload-list__item-preview"
          v-if="handlePreview && listType === 'picture-card'"
          @click="handlePreview(file)"
        >
          <i class="zm-icon-zoom-in"></i>
        </span>
        <span
          v-if="!disabled"
          class="zm-upload-list__item-delete"
          @click="$emit('remove', file)"
        >
          <i class="zm-icon-delete"></i>
        </span>
      </span>
    </li>
  </transition-group>
</template>
<script>
  import Locale from '../../mixins/locale';
  import ZmProgress from '../progress';

  export default {
    mixins: [Locale],

    data() {
      return {
        focusing: false
      };
    },
    components: {ZmProgress},

    props: {
      files: {
        type: Array,
        default() {
          return [];
        }
      },
      disabled: {
        type: Boolean,
        default: false
      },
      handlePreview: Function,
      listType: String
    },
    methods: {
      parsePercentage(val) {
        return parseInt(val, 10);
      },
      handleClick(file) {
        this.handlePreview && this.handlePreview(file);
      }
    }
  };
</script>

<style lang="scss">
  @import "../../scss/mixins/mixins";
  @import "../../scss/common/var";

  @include b(upload-list) {
    margin: 0;
    padding: 0;
    list-style: none;

    @include e(item) {
      transition: all .5s cubic-bezier(.55, 0, .1, 1);
      font-size: 14px;
      color: $--color-text-primary;
      line-height: 32px;
      margin-top: 5px;
      position: relative;
      box-sizing: border-box;
      border-radius: 4px;
      width: 100%;

      .zm-progress {
        position: absolute;
        top: 20px;
        width: 100%;
      }

      .zm-progress__text {
        position: absolute;
        right: 0;
        top: -13px;
      }

      .zm-progress-bar {
        margin-right: 0;
        padding-right: 0;
      }

      &:first-child {
        margin-top: 10px;
      }

      & .zm-icon-upload-success {
        color: $--color-success;
      }

      .zm-icon-close {
        display: none;
        position: absolute;
        top: 0;
        right: 5px;
        cursor: pointer;
        opacity: .75;
        color: $--color-text-primary;
        //transform: scale(.7);

        &:hover {
          opacity: 1;
        }
      }

      & .zm-icon-close-tip {
        display: none;
        position: absolute;
        top: 5px;
        right: 5px;
        font-size: 12px;
        cursor: pointer;
        opacity: 1;
        color: $--color-primary;
      }

      &:hover {
        background-color: $--background-color-base;

        .zm-icon-close {
          display: inline-block;
        }

        .zm-progress__text {
          display: none;
        }
      }

      @include when(success) {
        .zm-upload-list__item-status-label {
          display: block;
        }

        .zm-upload-list__item-name:hover, .zm-upload-list__item-name:focus {
          color: $--link-hover-color;
          cursor: pointer;
        }

        &:focus:not(:hover) { /* 键盘focus */
          .zm-icon-close-tip {
            display: inline-block;
          }
        }

        &:not(.focusing):focus, &:active { /* click时 */
          outline-width: 0;
          .zm-icon-close-tip {
            display: none;
          }
        }

        &:hover, &:focus {
          .zm-upload-list__item-status-label {
            display: none;
          }
        }
      }
    }

    @include when(disabled) {
      .zm-upload-list__item:hover .zm-upload-list__item-status-label {
        display: block;
      }
    }

    @include e(item-name) {
      color: $--color-text-primary;
      display: block;
      margin-right: 40px;
      overflow: hidden;
      padding-left: 4px;
      text-overflow: ellipsis;
      transition: color .3s;
      white-space: nowrap;

      [class^="zm-icon"] {
        height: 100%;
        margin-right: 7px;
        color: $--color-text-secondary;
        line-height: inherit;
      }
    }

    @include e(item-status-label) {
      position: absolute;
      right: 5px;
      top: 0;
      line-height: inherit;
      display: none;
    }

    @include e(item-delete) {
      position: absolute;
      right: 10px;
      top: 0;
      font-size: 12px;
      color: $--color-text-primary;
      display: none;

      &:hover {
        color: $--color-primary;
      }
    }

    @include m(picture-card) {
      margin: 0;
      display: inline;
      vertical-align: top;

      .zm-upload-list__item {
        overflow: hidden;
        background-color: #fff;
        border: 1px solid #c0ccda;
        border-radius: 6px;
        box-sizing: border-box;
        width: 148px;
        height: 148px;
        margin: 0 8px 8px 0;
        display: inline-block;

        .zm-icon-ok,
        .zm-icon-success {
          color: $--color-white;
        }

        .zm-icon-close {
          display: none;
        }
        &:hover {
          .zm-upload-list__item-status-label {
            display: none;
          }

          .zm-progress__text {
            display: block;
          }
        }
      }

      .zm-upload-list__item-name {
        display: none;
      }

      .zm-upload-list__item-thumbnail {
        width: 100%;
        height: 100%;
      }

      .zm-upload-list__item-status-label {
        position: absolute;
        right: -15px;
        top: -6px;
        width: 40px;
        height: 24px;
        background: #13ce66;
        text-align: center;
        transform: rotate(45deg);
        box-shadow: 0 0 1pc 1px rgba(0, 0, 0, 0.2);

        i {
          font-size: 12px;
          margin-top: 11px;
          transform: rotate(-45deg);
        }
      }

      .zm-upload-list__item-actions {
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        cursor: default;
        text-align: center;
        color: #fff;
        opacity: 0;
        font-size: 20px;
        background-color: rgba(0, 0, 0, .5);
        transition: opacity .3s;
        &::after {
          display: inline-block;
          content: "";
          height: 100%;
          vertical-align: middle
        }

        span {
          display: none;
          cursor: pointer;
        }

        span + span {
          margin-left: 15px;
        }

        .zm-upload-list__item-delete {
          position: static;
          font-size: inherit;
          color: inherit;
        }

        &:hover {
          opacity: 1;
          span {
            display: inline-block;
          }
        }
      }

      .zm-progress {
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        bottom: auto;
        width: 126px;

        .zm-progress__text {
          top: 50%;
        }
      }
    }

    @include m(picture) {
      .zm-upload-list__item {
        overflow: hidden;
        z-index: 0;
        background-color: #fff;
        border: 1px solid #c0ccda;
        border-radius: 6px;
        box-sizing: border-box;
        margin-top: 10px;
        padding: 10px 10px 10px 90px;
        height: 92px;

        .zm-icon-ok,
        .zm-icon-success {
          color: $--color-white;
        }

        &:hover {
          .zm-upload-list__item-status-label {
            background: transparent;
            box-shadow: none;
            top: -2px;
            right: -12px;
          }

          .zm-progress__text {
            display: block;
          }
        }

        &.is-success {
          .zm-upload-list__item-name {
            line-height: 70px;
            margin-top: 0;
            i {
              display: none;
            }
          }
        }
      }

      .zm-upload-list__item-thumbnail {
        vertical-align: middle;
        display: inline-block;
        width: 70px;
        height: 70px;
        float: left;
        position: relative;
        z-index: 1;
        margin-left: -80px;
      }

      .zm-upload-list__item-name {
        display: block;
        margin-top: 20px;

        i {
          font-size: 70px;
          line-height: 1;
          position: absolute;
          left: 9px;
          top: 10px;
        }
      }

      .zm-upload-list__item-status-label {
        position: absolute;
        right: -17px;
        top: -7px;
        width: 46px;
        height: 26px;
        background: #13ce66;
        text-align: center;
        transform: rotate(45deg);
        box-shadow: 0 1px 1px #ccc;

        i {
          font-size: 12px;
          margin-top: 12px;
          transform: rotate(-45deg);
        }
      }

      .zm-progress {
        position: relative;
        top: -7px;
      }
    }
  }
</style>
